import styled from 'styled-components'
import colors from '../colors.scss'

export const Divider = styled.div`
  padding: 0;
  margin: 15px 0 10px 0;
  border-top: 1px solid ${colors.dividerDark};
`
